import type { ICellRendererParams } from 'ag-grid-community';
import { Chip } from 'Components/atoms';
import React from 'react';
import type { Employee } from './usersTable';

/**
 * User score cell — matches legacy `Chip` `user_score` styling from the react-data-table grid.
 */
const UsersScoreCellRenderer: React.FC<ICellRendererParams<Employee, number>> = (params) => {
  const row = params.data;
  if (!row) {
    return null;
  }
  return (
    <div className="d-flex w-100 justify-content-center align-items-center h-100">
      <Chip variant="user_score" value={row.score.toString()} />
    </div>
  );
};

export default UsersScoreCellRenderer;
